module.exports = __webpack_public_path__ + "static/img/xxfw3.a1c5a33c.png";